import { createAsyncThunk } from '@reduxjs/toolkit';
import type { ServerListParams } from '@crm/shared';
import { extractError } from '../../store/thunkHelpers';
import { createCrudThunks } from '../../store/createCrudThunks';
import { taskApi } from './taskApi';
import type { Task, TaskCreatePayload, TaskStatus, TaskUpdatePayload } from './taskTypes';

/**
 * Fetch-all: pageSize alto per caricare l'intero set di task del gruppo in una
 * request. Serve a chi filtra/conteggia per stato DERIVATO dalle date
 * (imminent/expiring_today/expired), non filtrabile server-side — es. i tab di
 * TaskList e il box "Scaduti" della Dashboard. Il backend già materializza
 * tutto in memoria (QueryUtil.ALL_POS + subList), quindi non introduce costi
 * aggiuntivi rispetto alla paginazione server.
 */
export const FETCH_ALL_PAGE_SIZE = 10000;

const thunks = createCrudThunks<Task, TaskCreatePayload, TaskUpdatePayload, ServerListParams>(
  'tasks',
  taskApi,
);

/**
 * Transizione di stato dedicata: PATCH /task/{taskId}/status.
 * Separato dall'`update` generico perche' BE post-608fde16 espone un
 * endpoint distinto e valida il body con `TaskStatus.isValid`.
 */
export const updateTaskStatus = createAsyncThunk<
  Task,
  { taskId: number; status: TaskStatus },
  { rejectValue: string }
>('tasks/updateStatus', async ({ taskId, status }, { rejectWithValue }) => {
  try {
    return await taskApi.updateStatus(taskId, status);
  } catch (err) {
    return rejectWithValue(extractError(err));
  }
});

export const taskThunks = thunks;
export const {
  fetchAll: fetchTasks,
  fetchOne: fetchTask,
  create: createTask,
  update: updateTask,
  remove: deleteTask,
} = thunks;
